<template>
  <div
    class="wl-switch relative w-10 cursor-pointer rounded-full p-0.5 transition duration-150"
    :class="[
      {
        'is-disabled opacity-30': isDisabled,
      },
      modelValue ? 'is-checked bg-accent-emphasis' : 'bg-emphasis',
    ]"
    @click.stop="handleToggle"
  >
    <input
      :id="id"
      ref="inputRef"
      type="checkbox"
      class="absolute inset-0 cursor-pointer opacity-0"
      :disabled="isDisabled"
      :value="modelValue"
      @click.stop
      @change.stop="handleToggle"
    />
    <div
      class="wl-check-circle size-4 rounded-full bg-default shadow-down-sm transition duration-150"
      :class="{
        'is-checked translate-x-5': modelValue,
      }"
    />
  </div>
</template>
<script setup lang="ts">
import { useWebHaptics } from "../../composables/use-web-haptics";
import type { SwitchEmits, SwitchProps } from "./types";

const emit = defineEmits<SwitchEmits>();
const {
  id,
  modelValue,
  isDisabled = false,
  haptic = "soft",
} = defineProps<SwitchProps>();

const { triggerHaptic } = useWebHaptics();

const handleToggle = (): void => {
  if (isDisabled) {
    return;
  }

  triggerHaptic(haptic);
  emit("update:modelValue", !modelValue);
};
</script>
